import * as yup from 'yup';

export const BASE_SCHEMA = {
  createdAt: yup.mixed().default(null),
  updatedAt: yup.mixed().default(null),
  createdBy: yup.mixed().default(null),
  updatedBy: yup.mixed().default(null),
};
